import Head from 'next/head'
import Typography from '@mui/material/Typography'
import { Box, Stack, Tooltip, useMediaQuery } from '@mui/material'
import { TranslateMessage, useTranslation } from '@app/lib/lang'
import { CustomDivider } from './CustomDivider'
import { BreadcrumbItem } from '@app/@types'
import { CustomBreadcrumbs } from './Breadcrumbs'
import { themeColors } from '@app/constants'
import { ReactNode } from 'react'
import { ConditionalWrapper } from './ConditionalWrapper'
interface HeaderProps {
	children?: ReactNode
	heading?: string
	description?: string
	hideBottomDivider?: boolean
	breadcrumbs?: BreadcrumbItem[]
	additionalBreadcrumbs?: BreadcrumbItem[]
	numberOfLines?: number
	isTitle?: boolean
	isSmallerHeading?: boolean
}

export default function Header({
	children,
	heading = '',
	description = '',
	hideBottomDivider = false,
	breadcrumbs,
	additionalBreadcrumbs,
	numberOfLines,
	isTitle = false,
	isSmallerHeading = false,
}: HeaderProps) {
	const { t } = useTranslation()

	const isSmallScreen = useMediaQuery('(max-width: 1400px)')
	return (
		<>
			{heading && (
				<Head>
					<title>{t(heading)}</title>
				</Head>
			)}

			<Box>
				{breadcrumbs && (
					<Box mb="16px">
						<CustomBreadcrumbs
							breadcrumbs={breadcrumbs}
							additionalBreadCrumbs={additionalBreadcrumbs}
						/>
					</Box>
				)}

				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					gap="10px"
					height="46px"
				>
					<Box>
						<ConditionalWrapper
							condition={isSmallScreen}
							wrapper={(children) => (
								<Tooltip title={heading ? t(heading) : ''}>
									{children}
								</Tooltip>
							)}
						>
							<Typography
								variant={isSmallerHeading ? 'h4' : 'h3'}
								sx={
									numberOfLines
										? {
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												display: '-webkit-box',
												WebkitLineClamp: numberOfLines,
												WebkitBoxOrient: 'vertical',
												minWidth: '200px',
										  }
										: undefined
								}
							>
								<TranslateMessage
									id={heading}
									isTitle={isTitle}
								/>
							</Typography>
						</ConditionalWrapper>
						<Typography
							color={themeColors.brownishGrey}
							fontSize={14}
						>
							<TranslateMessage id={description} />
						</Typography>
					</Box>

					<Stack direction="row" justifyContent="flex-end" gap="10px">
						{children}
					</Stack>
				</Stack>
			</Box>

			{!hideBottomDivider && <CustomDivider mb={3} mt={3} />}
		</>
	)
}
